import * as Yup from "yup";

export const productValidation = Yup.object().shape({
  name: Yup.string().nullable().min(25).required("Name is required"),
  description: Yup.string().nullable().min(40).required("Description is required"),
  isVariant: Yup.bool(),
  isSingleVariant: Yup.bool(),
  details: Yup.array().of(
    Yup.object().shape({
      marketplaceSKU: Yup.string().nullable().required("Marketplace SKU is required"),
      name: Yup.string().nullable().required("Name is required"),
      sellingPrice: Yup.number()
        .min(1, "Selling Price must be greater than or equal to 0")
        .required("Selling Price is required"),
      costPrice: Yup.number()
        .min(0, "Cost Price must be greater than or equal to 0")
        .required("Cost Price is required"),
      // images: Yup.array().min(1,"Images is required").when("isVariant",{
      //   is: true,
      //   then:(schema)=>schema.min(1).required()
      // }),
    })
  ),
  images: Yup.array().min(1).required("Images is required"),
  //sizeChart: Yup.array().min(1).required("Size Chart is required"),
  // variations: Yup.array().of(
  //   Yup.object().shape({
  //     name: Yup.string().nullable().required("Variation Name is required"),
  //     //values: Yup.array().of(Yup.string()).required("Variation Value is required"),
  //     values: Yup.array().min(1, "Variation Value is required"),
  //   })
  // ),
  packageWeight: Yup.number().moreThan(0, "Package Weight must be greater than 0").required(),
  packageLength: Yup.number().min(1, "Package Length must be greater than 1").required(),
  packageWidth: Yup.number().min(1, "Package Width must be greater than 1").required(),
  packageHeight: Yup.number().min(1, "Package Height must be greater than 1").required(),
  magento: Yup.object().shape({
    select: Yup.boolean(),
    color: Yup.string()
      .nullable(),
      // .when("select", {
      //   is: true,
      //   then: (schema) => schema.required("Color is required"),
      // }),
    material: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Material is required"),
      }),
    type: Yup.array().when("select", {
      is: true,
      then: (schema) => schema.min(1, "Type is required"),
    }),
    opacity: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Opacity is required"),
      }),
    texture: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Texture is required"),
      }),
    thickness: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Thickness is required"),
      }),
    //relatedProduct: Yup.string().nullable().required("Related Product is required"),
  }),
});

export const productEditValidation = Yup.object().shape({
  name: Yup.string().nullable().min(25).required("Name is required"),
  description: Yup.string().nullable().min(40).required("Description is required"),
  isVariant: Yup.boolean(),
  isSingleVariant: Yup.boolean(),
  details: Yup.array().of(
    Yup.object().shape({
      marketplaceSKU: Yup.string().nullable().required("Marketplace SKU is required"),
      name: Yup.string().nullable().required("Name is required"),
      sellingPrice: Yup.number()
        .min(1, "Selling Price must be greater than or equal to 0")
        .required("Selling Price is required"),
      costPrice: Yup.number()
        .min(0, "Cost Price must be greater than or equal to 0")
        .required("Cost Price is required"),
      // images: Yup.array().min(1,"Images is required").when("isVariant",{
      //   is: true,
      //   then:(schema)=>schema.min(1).required()
      // }),
    })
  ),
  // variations: Yup.array().of(
  //   Yup.object().shape({
  //     name: Yup.string().nullable().required("Variation Name is required"),
  //     //values: Yup.array().of(Yup.string()).required("Variation Value is required"),
  //     values: Yup.array().min(1, "Variation Value is required"),
  //   })
  // ),
  packageWeight: Yup.number().moreThan(0, "Package Weight must be greater than 0").required(),
  packageLength: Yup.number().min(1, "Package Length must be greater than 1").required(),
  packageWidth: Yup.number().min(1, "Package Width must be greater than 1").required(),
  packageHeight: Yup.number().min(1, "Package Height must be greater than 1").required(),
  magento: Yup.object().shape({
    select: Yup.boolean(),
    // color: Yup.string()
    //   .nullable()
    //   .when("select", {
    //     is: true,
    //     then: (schema) => schema.required("Color is required"),
    //   }),
    material: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Material is required"),
      }),
    type: Yup.array().when("select", {
      is: true,
      then: (schema) => schema.min(1, "Type is required"),
    }),
    opacity: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Opacity is required"),
      }),
    texture: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Texture is required"),
      }),
    thickness: Yup.string()
      .nullable()
      .when("select", {
        is: true,
        then: (schema) => schema.required("Thickness is required"),
      }),
    //relatedProduct: Yup.string().nullable().required("Related Product is required"),
  }),
});
